"use strict";
exports.__esModule = true;
exports.HttpConnection = void 0;
/**
 * A connection to a DriftDB room over HTTP.
 *
 * This is mainly used in environments where WebSockets are not available.
 */
var HttpConnection = /** @class */ (function () {
    function HttpConnection(httpUrl) {
        this.httpUrl = httpUrl;
    }
    HttpConnection.prototype.send = function (message) {
        return fetch(this.httpUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(message)
        }).then(function (response) {
            if (!response.ok) {
                throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText));
            }
            return response.json();
        });
    };
    return HttpConnection;
}());
exports.HttpConnection = HttpConnection;
